import React from "react";
import { Container } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";


const SuppliesAlertPage = () => {

    return (
        <Container>
            <PageTitle
                pageTitle={`Supplies Alerts`}
                showBreadcrumb={[
                    { label: "Home", to: "/" },
                ]}
                BreadCrumbCurrentPageTitle={"Supplies Alerts"}
                showLastSeen={true}
            />
            <div className="sectionBox">

            </div>
        </Container>
    )
}
export default SuppliesAlertPage;